<template>
  <div class="rodent-other" v-loading="loading">
    <xph :_devs="devs" v-if="type === 'xph' && !loading" />
    <ykm :_devs="devs" v-else-if="type === 'ykm' && !loading" />
  </div>
</template>

<script>
import Ykm from './ykm'
import Xph from './xph'

import sleep from '@/utlis/sleep'

import { getDevices } from '@/service/ykm'

export default {
  components: { Ykm, Xph },
  data() {
    return {
      loading: false,
      devs: [],
      type: ''
    }
  },
  mounted() {
    this.getDevs()
  },
  methods: {
    async getDevs() {
      this.loading = true
      let [{ data }] = await Promise.all([
        getDevices({ companyId: this.companyId }),
        sleep(1)
      ])
      this.devs.splice(0, this.devs.length, ...data)
      this.type = this.devs.find(d => d.type === 'xph') ? 'xph' : 'ykm'
      this.loading = false
    }
  }
}
</script>

<style lang="css" scoped>
.rodent-other {
  width: 100%;
  height: 100%;
}
</style>
